import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const Switcher = styled.div`
  display: inline-flex;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;

  button {
    padding: 6px 14px;
    background: #fff;
    border: none;
    border-right: 1px solid #ccc;
    cursor: pointer;
    font-size: 13px;
    color: #444;
  }
  button:last-child {
    border-right: none;
  }
  button.active {
    background: #1976d2;
    color: #fff;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  text-align: left;
  padding: 8px 12px;
  background: #f7f7f7;
  border-bottom: 1px solid #ddd;
  ${({ width }) => (width ? `width: ${width};` : '')}
`;

export const TdDate = styled.td`
  padding: 12px;
  vertical-align: top;
  white-space: nowrap;
  border-bottom: 1px solid #eee;

  a {
    color: #1976d2;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;

export const TdImages = styled.td`
  padding: 12px;
  vertical-align: top;
  border-bottom: 1px solid #eee;
`;

export const Strip = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow-x: auto;
  max-width: 100%;
  padding-bottom: 4px;
`;

export const Thumb = styled.button`
  flex: 0 0 auto;
  width: 96px;
  height: 96px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0;
  background: #fff;
  cursor: pointer;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &:hover {
    border-color: #1976d2;
  }
`;

export const Empty = styled.div`
  padding: 32px;
  text-align: center;
  color: #888;
  font-style: italic;
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  justify-content: center;

  button {
    padding: 6px 12px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    max-width: 86vw;
    max-height: 80vh;
    object-fit: contain;
  }
`;

export const ModalCaption = styled.div`
  margin-top: 8px;
  color: #555;
  font-size: 13px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 4px;
  right: 8px;
  font-size: 28px;
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 1;
  color: #444;
`;
